import React from 'react';
import Layout from '../components/layout';

function experience() {
    return (
        <Layout>
            <div className="grid-item">
                <div className="grid-content">
                    <div id="experienceDiv">
                        <h3>Technologies</h3>
                        <p>
                            C#, JavaScript, HTML, CSS, Xamarin, Angular, React, Gatsby, SQL
                        </p>
                        <h3>Work History</h3>
                        <p>
                            <b>Centare</b>
                        </p>
                        <p>
                            <em>June 2019 - Present</em>
                        </p>
                        <p>
                            As a consultant at Centare, I work hard to provide the maximum value to clients. My goal is to provide technical and soft-skill solutions while getting product out the door.
                        </p>
                        <p>
                            <b>Omnigo Software</b>
                        </p>
                        <p>
                            <em>October 2015 - June 2019</em>
                        </p>
                        <p>
                            I was on a agile team developing a Xamarin.Forms app in Android and iOS, along with accompanying websites and modifying current enterprise applications.
                        </p>
                        <p>
                            <b>Great Lakes Solutions, LLC</b>
                        </p>
                        <p>
                            <em>December 2012 - October 2015</em>
                        </p>
                        <p>
                            An internship that transitioned into a full-time job. I was a full-stack developer and full-stack professional. I primarily worked on ASP.NET TMS web applications. 
                            I also needed to develop console apps that interpreted and saved information from EDI files. I worked closely with clients, gathering business requirements and 
                            supporting their needs.
                        </p>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default experience;